export default __webpack_public_path__ + "static/media/brc.07aca2a9.svg";